import { getRequest, postRequest } from "../../apiClient";
import { AuthEndpoint } from "../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetUserDetailsService = async (queryString: any) => {
    var _url = AuthEndpoint.USER_DETAILS + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const LoginUserService = async (param: any) => {
    var _url = AuthEndpoint.LOGIN
    var res: any = await postRequest(_url, param);

    return res;
};

export const SignupService = async (param: any) => {
    var res = await postRequest(AuthEndpoint.SIGN_UP, param);

    return res;
};

export const ForgotPasswordService = async (param: any) => {
    var res = await postRequest(AuthEndpoint.FORGOT_PASSWORD, param);

    return res;
};

export const VerifyPasswordService = async (param: any) => {
    var res = await postRequest(AuthEndpoint.VERIFY_PASSWORD, param);

    return res;
};

export const Setup2FAService = async (param: any) => {
    var res = await postRequest(AuthEndpoint.SETUP_2FA, param);

    return res;
};

export const Confirm2FAService = async (param: any) => {
    var res = await postRequest(AuthEndpoint.CONFIRM_2FA, param);

    return res;
};

export const Disable2FAService = async (param: any) => {
    var res = await postRequest(AuthEndpoint.DISABLE_2FA, param);

    return res;
};

export const VerifyLogin2FAService = async (param: any) => {
    var res = await postRequest(AuthEndpoint.VERIFY_LOGIN_2FA, param);

    return res;
};

export const Recover2FAService = async (param: any) => {
    var res = await postRequest(AuthEndpoint.RECOVER_2FA, param);

    return res;
};

export const VerifyRecover2FAService = async (param: any) => {
    var res = await postRequest(AuthEndpoint.VERIFY_RECOVER_2FA, param);

    return res;
};
//#endregion